import { Map } from 'immutable';

import {
    DelayRepayPages,
    CompensationPages,
    AutoDelayRepayPages,
    AccountPages
} from '../../src/constants/AppConstants';

/*
    Note: Besides defining DR routes, this is used also by build/buildConfig.js
          for the dev build.

    If you make any changes/additions to these URLs, you might need to restart
    your local dev server to see the changes.
*/

export default new Map({
    [ DelayRepayPages.CUSTOMER ]: '/customer-details',
    [ DelayRepayPages.CLAIMS ]: '/claims',
    [ DelayRepayPages.PAYMENT ]: '/payment-method',
    [ DelayRepayPages.CONFIRM ]: '/confirm',

    [ CompensationPages.DETAILS ]: '/compensation',
    [ CompensationPages.PRE_APPROVED ]: '/compensation/pre-approved',
    [ CompensationPages.SEASON ]: '/compensation/apply',
    [ CompensationPages.NON_SEASON ]: '/compensation/non-season',

    [ AutoDelayRepayPages.SUBSCRIPTION ]: '/auto/:action/:token',

    [ AccountPages.AUTO_DELAY_REPAY ]: '/account/auto-delay-repay'
});



// WEBPACK FOOTER //
// ./delay-repay/src/urls.js